// 红黑榜管理页面
import viewRedBlack from '@/core/components/viewRedBlack'
import address from '@/pages/address'
import searchRole from '@/core/components/searchRole'
import { tkParse, tkDate } from '@moke/vue-tk'
// const reg = /^1[3456789]\d{9}$/

export default {
  className: 'redBlack',
  fields: [
    {
      name: 'redTitle',
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'user',
      note: '发布用户',
      listWhere: (where) => {
        where.authority = {
          $ne: 'administrator'
        }
      },
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'redImg'
    },
    {
      name: 'video'
    },
    {
      name: 'redType',
      width: 100,
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'redRole',
      width: 200,
      view: {
        component: viewRedBlack
      },
      edit: {
        component: searchRole
      },
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'redName',
      note: '姓名或名称',
      placeholder: '个人请填写姓名',
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'phone'
      // validators: [
      //   (value) => value ? null : '不可为空',
      //   (val) => !reg.test(val) ? '请输入正确格式手机号' : null

      // ]
      // disabled: true
    },
    {
      name: 'detailAddress',
      validators: [
        (value) => value ? null : '详细地址不可为空'
      ]
    },
    {
      name: 'redStatus',
      width: 150
    },
    {
      name: 'redRead',
      width: 150
    }
  ],
  search: [
    {
      name: 'redType'
    },
    {
      name: 'redRole',
      search: {
        component: searchRole
      }
    },
    {
      name: 'redName',
      note: '姓名或名称'
    },
    'redStatus'
  ],
  action: {
    create: {
      component: address
    },
    edit: {
      text: '审核'
    },
    export: false,
    delete: {
      type: 'row',
      text: '删除',
      callback: async ({ record, vm, className }) => {
        await vm.confirm('警告', '你确定要删除这条记录吗?')
        // 刪除此条商家信息
        let rs = await vm.$tkParse.put('/classes/' + className + '/' + record.objectId, { isDelete: true }).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '删除数据失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: ''
          })
          vm.refresh()
        }
      }
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.isDelete = false
    },
    async beforeUpdate ({ data }) {
      console.log('数据', data)
      if (data.user) {
        console.log('进来了')
        let user = await tkParse.get(`/classes/_User/${data.user}`)
        if (user.data.wxToken) {
          await tkParse.post('/wx/sendMsg', {
            token: user.data.wxToken,
            first: '您发布的红黑榜有审核结果了',
            keyword1: data.redStatus === 'wait' ? '待审核' : data.redStatus === 'pass' ? '已通过' : '未通过',
            keyword2: tkDate(new Date()).format()
          })
        }
        console.log(user.data.wxToken)
      }
    }
  }
}
